export const calculateLandingWeight = (data, reqFuel) => {
  const extraFuel = (
    reqFuel - (data?.nBlockFuel_KG / 1000 + 0.05).toFixed(1)
  ).toFixed(1);
  const landingWeight = parseInt(data?.nEstLW_KG) + extraFuel * 1000 ?? 0;
  return landingWeight;
};
